import { WentWrong as WentWrong_filmzi } from './WentWrong.filmzi';
import { WentWrong as WentWrong_kojaro } from './WentWrong.kojaro';
import { WentWrong as WentWrong_pedal } from './WentWrong.pedal';
import { WentWrong as WentWrong_zoomg } from './WentWrong.zoomg';
import { WentWrong as WentWrong_zoomit } from './WentWrong.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return WentWrong_filmzi;

    case 'kojaro':
      return WentWrong_kojaro;

    case 'pedal':
      return WentWrong_pedal;

    case 'zoomg':
      return WentWrong_zoomg;

    default:
      return WentWrong_zoomit;
  }
};

export const WentWrong = IconRenderer();
